import { render, staticRenderFns } from "./StudentNotes.vue?vue&type=template&id=ff6c75fc&scoped=true&"
import script from "./StudentNotes.vue?vue&type=script&lang=js&"
export * from "./StudentNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6c75fc",
  null
  
)

export default component.exports